import { Navigate } from "react-router-dom";
import { hasViewPermission } from "../../Utils/stringFormatter";

const ProtectedRoute = ({ element: Component, compareName }) => {
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem("token"));
  } catch {
    localStorage.removeItem("token");
  }
  const isLoggedIn = !!token;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  //  Check if ANY module has permission
  if (
    compareName &&
    Array.isArray(compareName) &&
    !compareName.some((name) => hasViewPermission(name))
  ) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;

// import React from "react";
// import { Navigate } from "react-router-dom";

// const hasTabAccess = (compareName = []) => {
//   const permissionModuleList =
//     JSON.parse(localStorage.getItem("permissions")) || [];

//   if (!Array.isArray(compareName)) return false;

//   return permissionModuleList.some((module) =>
//     compareName.some(
//       (name) =>
//         module.compareName?.replace(/\s+/g, "").toLowerCase() ===
//           name?.replace(/\s+/g, "").toLowerCase() && module.isaccessible === 1
//     )
//   );
// };

// const ProtectedRoute = ({
//   element: Component,
//   permission = false,
//   redirectTo = "/login",
//   compareName = [],
// }) => {
//   const finalPermission =
//     compareName.length > 0 ? hasTabAccess(compareName) : permission;

//   return finalPermission ? <Component /> : <Navigate to={redirectTo} replace />;
// };

// export default ProtectedRoute;
